import { Component, input, output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormArrayTableComponent } from '@app/ui-components/form-array-table/form-array-table.component';
import { ValidatedNumberInputComponent } from '@app/ui-components/validated-number-input/validated-number-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ApplicableInterestRatesFormGroup } from './applicable-interest-rates-form.helper';

@Component({
  selector: 'app-applicable-interest-rates',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    FormArrayTableComponent,
    ValidatedNumberInputComponent,
  ],
  templateUrl: './applicable-interest-rates.component.html',
  styleUrl: './applicable-interest-rates.component.scss',
})
export class ApplicableInterestRatesComponent {
  formControls =
    input.required<FormArray<FormGroup<ApplicableInterestRatesFormGroup>>>();
  title = input.required<string>();
  canAdd = input(false);
  createNewFileGroup = output<void>();
  rowRemoveClicked = output<number>();
  protected translationKey = 'applicableInterestRate.';
  onFormSubmit(event: Event): void {
    event.preventDefault();
  }
  onEnterKey(event: Event): void {
    event.preventDefault();
  }
}
